<div *ngIf="show" class="message alert alert-{{ type }}" [innerHtml]="message | safeHtml" routeLink>
  <div *ngFor="let item of messages| keyvalue">
    {{item.key}}: {{item.value}}
  </div>
</div>
